import { graphql } from 'gatsby'
import * as PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import FeaturesModel from '../../datas/models/Features'
import ReviewsModel from '../../datas/models/Reviews'
import SeoModel from '../../datas/models/Seo'
import asTemplate from '../../root/Template'
import { getContentfulField, withTransformer } from '../../utils/GatsbyUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { localize } from '../../utils/TranslationUtils'
import PortfolioProject from '../../datas/models/PortfolioProject'
import Seo from '../../components/Seo'

import HomeContact from './HomeContact'
import HomeCover from './HomeCover'
import HomeFeatures from './HomeFeatures'
import HomeProjects from './HomeProjects'
import HomeBrands from './HomeBrands'
import HomeReviews from './HomeReviews'


const mapSelectors = () => ({
  //
})

const mapActions = dispatch => ({
  //
})

function transformer(data) {
  const { contentfulHomeTemplate, allContentfulDomain } = data

  const domains = allContentfulDomain?.edges
  const projects = contentfulHomeTemplate.projects

  if (contentfulHomeTemplate) {
    return {
      homePageData: {
        baseline: contentfulHomeTemplate.baseline,
        features: FeaturesModel(contentfulHomeTemplate.features),
        reviews: ReviewsModel(contentfulHomeTemplate.reviews),
        recruitTitle: contentfulHomeTemplate.recruitTitle,
        recruitDescription: getContentfulField(contentfulHomeTemplate, 'recruitDescription'),
        seo: SeoModel(contentfulHomeTemplate.seo),
      },
      onDisplayProjects:
      projects?.map(project => PortfolioProject(project)),
      domains
    }
  }
}

const decorators = [
  asTemplate,
  localize,
  withTransformer(transformer),
  connect(mapSelectors, mapActions),
  memoized,
]

function HomepageTemplate(props) {
  const { homePageData, t, locale, onDisplayProjects, domains } = props

  return (
    <>
      <Seo {...homePageData.seo} />
      <HomeCover baseline={homePageData.baseline} />
      <HomeFeatures features={homePageData.features} t={t} />
      <HomeProjects
        title={t('ourCases')}
        floatingTitle={t('ourCasesFloating')}
        locale={locale}
        domains={domains}
        onDisplayProjects={onDisplayProjects}
        webCta={t('discoverAllProjectsCTA')}
        t={t}
      />
      <HomeReviews reviews={homePageData.reviews} sectionTitle={t('homeReviewsSectionTitle')} />
      <HomeBrands t={t} />
      <HomeContact
        title={t('haveAnIdea')}
        contactEmail={t('contactEmail')}
      />
    </>
  )
}

HomepageTemplate.propTypes = {
  homePageData: PropTypes.shape({
    baseline: PropTypes.string,
    features: FeaturesModel.propTypes,
    recruitTitle: PropTypes.string,
    recruitDescription: PropTypes.string,
    seo: SeoModel.propTypes,
    translations: PropTypes.objectOf(PropTypes.string),
  }),
  mobileProjects: PropTypes.arrayOf(PortfolioProject.propTypes),
  webProjects: PropTypes.arrayOf(PortfolioProject.propTypes),
  onDisplayProjects: PropTypes.arrayOf(PortfolioProject.propTypes),
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
}

HomepageTemplate.defaultProps = {
  homePageData: {
    baseline: '',
    features: FeaturesModel.defaultProps,
    recruitTitle: '',
    recruitDescription: '',
    seo: SeoModel.defaultProps,
    translations: {},
  },
  mobileProjects: [],
  webProjects: [],
  onDisplayProjects: [],
}

HomepageTemplate = chainDecorators(decorators, HomepageTemplate)

export default HomepageTemplate

export const query = graphql`
    query($langKey: String!) {
        allContentfulDomain(filter: { node_locale: { eq: $langKey } }) {
          edges {
            node {
              ...bbsContentfulDomain
            }
          }
        }
        contentfulHomeTemplate(node_locale: { eq: $langKey }) {
            ...bbsContentfulHomeTemplate
        }
    }
`

// export const query = graphql`
//     query($langKey: String!) {
//         allContentfulProjectTemplate(filter: { node_locale: { eq: $langKey } }) {
//             edges {
//                 node {
//                     ...bbsContentfulProjectTemplate
//                 }
//             }
//         }
//         contentfulHomeTemplate(node_locale: { eq: $langKey }) {
//             ...bbsContentfulHomeTemplate
//         }
//     }
// `
